import React from 'react'
import Typography from '@mui/material/Typography'
export default function NotFoundPage() {
  return <Typography component='h1'>Page Not Found</Typography>
}
